import React, { Component } from "react";
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { Navigate } from "react-router-dom";
import CompetitionService from "../services/competition-service";
import AuthService from "../services/auth-service";
import CustomGridLoadingOverlay from '../components/custom-grid-loading-overlay-component';
import Grid from '@mui/material/Grid';
import { DataGrid, GridToolbarContainer, GridToolbarColumnsButton, GridToolbarFilterButton} from '@mui/x-data-grid'; 


function CustomToolbar(props) {
  const { addAction } = props;
  return (
    <GridToolbarContainer>
      <Grid container justifyContent="flex-start">
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
    </Grid>
    </GridToolbarContainer>
  );
}

export default class Archive extends Component {
  constructor(props) {
    super(props);
    this.state = {
      redirect: null,
      competitions: [],
      currentUser: null,
      showSpinner: false
    };
  }

  downloadRules = (competition) => () => {
    const link = document.createElement("a");
    link.href = competition.rules
    link.setAttribute('download', "regolamento "+competition.title+".pdf")
    link.click();
  };

  navigateTo = (competition) => () => {
    this.setState({
      redirect: "/competition/"+competition.id
    })
  };

  navigateToRegistration = (competition) => () => {
    this.setState({
      redirect: "/competition/"+competition.id+"/registration"
    })
  };

  componentDidMount() {
    const currentUser = AuthService.getCurrentUser();
    this.setState({
      currentUser: currentUser,
      showSpinner: true
    });
    CompetitionService.getArchived().then((competitionsResponse) => {
      if (currentUser.roles.includes("ROLE_SUPERADMIN")) {
        this.setState({
          competitions: competitionsResponse.data,
          showSpinner: false
        });
      } else {
        this.setState({
          competitions: competitionsResponse.data.filter((comp) => { return comp.hidden == false }),
          showSpinner: false
        });
      }
    }).catch((errorResponse) => {
      console.log(errorResponse);
    });
  }

  render() {
    if (this.state.redirect) {
      return <Navigate to={this.state.redirect} />
    }

    const columns = [
      { field: 'title', headerName: 'Titolo', width: 200 },
      { field: 'city', headerName: 'Città', width: 150 },
      { field: 'date', headerName: 'Data Inizio', width: 150 },
      { field: 'dateEnd', headerName: 'Data Fine', width: 150 },
      { field: 'registrationEnd', headerName: 'Chiusura Iscrizioni', width: 200 },
      { field: 'actions', headerName: 'Azioni', width: 250, renderCell: (params) => {
        return (
          <div>
            {this.state.currentUser && (this.state.currentUser.roles.includes("ROLE_SUPERADMIN") || (this.state.currentUser.roles.includes("ROLE_ADMIN") && params.row.admins.includes(this.state.currentUser.email))) && (
              <Button size="small" onClick={this.navigateTo(params.row)}>Gestisci</Button>
            )}
            {this.state.currentUser && (this.state.currentUser.roles.includes("ROLE_SUPERADMIN") || ((this.state.currentUser.roles.includes("ROLE_USER") || (this.state.currentUser.roles.includes("ROLE_ADMIN") && params.row.admins.includes(this.state.currentUser.email))) && params.row.enabled)) && (
              <Button size="small" onClick={this.navigateToRegistration(params.row)}>Iscrizioni</Button>
            )}
            {this.state.currentUser && params.row.rules && (
              <Button size="small" onClick={this.downloadRules(params.row)}>Scarica Regolamento</Button>
            )}
          </div>
        );
      }}
    ];

    const rows = this.state.competitions.map((competition) => ({
      id: competition.id,
      title: competition.title,
      city: competition.city,
      date: competition.date,
      dateEnd: competition.dateEnd,
      registrationEnd: competition.registrationEnd,
      admins: competition.admins.map(admin => admin.email),
      enabled: competition.enabled,
      rules: competition.rules
    }));

    return (
      <div className="container">
        {this.state.showSpinner && (
          <div className="flex items-center justify-center mt-10 text-center px-6 py-6">
            <Box sx={{ py: 8 }}>
              <CircularProgress />
            </Box>
          </div>
        )}
        {!this.state.showSpinner && (
          <div>
            <header className="jumbotron">
              {/* Rimosso il Container e usato un div senza limitazioni di larghezza */}
              <div style={{ height: 500, width: '100%' }}>
                <DataGrid
                  rows={rows}
                  columns={columns}
                  pageSize={5}
                  rowsPerPageOptions={[5, 10, 25]}
                  disableSelectionOnClick
                  components={{
                    Toolbar: CustomToolbar,
                    LoadingOverlay: CustomGridLoadingOverlay,
                  }}
                />
              </div>
            </header>
          </div>
        )}
      </div>
    );
  }
}
